/* ============================================================
   Diesel sticky info-card controller (desktop >= 990px only).

   The info card (.product__info-container) and the white accordions box
   (.diesel-details__box) live in two SEPARATE Shopify sections, so plain
   `position: sticky` releases too early (at the product section bottom).

   This controller pins the card with `position: fixed` while scrolling, lets
   it travel DOWN past the product section and into the red full-bleed band,
   and RELEASES it at the exact point where the card's BOTTOM edge is level with
   the BOTTOM edge of the white box. From there it scrolls away with the page.

   Progressive enhancement: if JS is off, the white box is missing, or the
   viewport is below 990px, the card falls back to the CSS rules (sticky on
   desktop, normal flow on mobile) — nothing here runs on mobile.
   ============================================================ */
(function () {
  var MQ = '(min-width: 990px)';

  var card = document.querySelector('.product__info-container');
  if (!card) return;

  var wrapper = card.closest('.product__info-wrapper');
  if (!wrapper) return;

  var remPx = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
  var OFFSET = 1.5 * remPx; // matches the CSS `top: 1.5rem` pin offset

  var active = false; // JS is controlling the card (desktop only)
  var pinned = false; // card is currently fixed
  var ticking = false;

  function whiteBox() {
    return document.querySelector('.diesel-details__box');
  }

  function clearCard() {
    card.style.position = '';
    card.style.top = '';
    card.style.left = '';
    card.style.width = '';
    card.style.margin = '';
    pinned = false;
  }

  function update() {
    ticking = false;
    if (!active) return;

    var box = whiteBox();
    if (!box) {
      // No shared red band on this page — defer to CSS `position: sticky`.
      if (pinned) clearCard();
      return;
    }

    var scrollY = window.pageYOffset;

    // Geometry is read from elements that stay in normal flow (the wrapper is a
    // fixed-width flex item stretched to the gallery height, so removing the
    // card from flow never collapses it) — keeps measurements stable.
    var wrapperRect = wrapper.getBoundingClientRect();
    var wrapperTopDoc = wrapperRect.top + scrollY;
    var left = wrapperRect.left;
    var width = wrapperRect.width;
    var cardH = card.offsetHeight;

    var boxBottomDoc = box.getBoundingClientRect().bottom + scrollY;

    var pinStart = wrapperTopDoc - OFFSET;
    var releaseAt = boxBottomDoc - cardH - OFFSET;

    if (scrollY < pinStart) {
      // Card hasn't reached the pin offset yet — leave it in normal flow.
      if (pinned) clearCard();
      return;
    }

    // Pinned. Clamp the top so the card's bottom never passes the white box
    // bottom: once scrollY > releaseAt the top decreases below OFFSET, so the
    // card scrolls away with the page instead of continuing into the footer.
    var top = OFFSET;
    if (scrollY > releaseAt) top = boxBottomDoc - cardH - scrollY;

    card.style.position = 'fixed';
    card.style.top = Math.round(top) + 'px';
    card.style.left = Math.round(left) + 'px';
    card.style.width = Math.round(width) + 'px';
    card.style.margin = '0';
    pinned = true;
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }

  function apply() {
    var on = window.matchMedia(MQ).matches;
    if (on && !active) {
      active = true;
      window.addEventListener('scroll', onScroll, { passive: true });
      update();
    } else if (!on && active) {
      active = false;
      window.removeEventListener('scroll', onScroll);
      clearCard();
    } else if (on) {
      update();
    }
  }

  window.addEventListener('resize', apply);

  // Accordions inside the white box change its height, which moves the release
  // point — recompute when one toggles.
  document.addEventListener(
    'toggle',
    function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('diesel-acc')) {
        requestAnimationFrame(update);
      }
    },
    true
  );

  apply();
  window.addEventListener('load', apply); // re-measure after fonts/images settle
})();
